import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getShippingLabelScans = {
  name: "getShippingLabelScans" as const,
  input: z.object({ inventoryItemId: inventoryItemIdFormat.schema }),
  output: z.object({
    scans: z.array(
      z.object({
        scanId: z.string(),
        status: z.string(),
        // Short-lived presigned GET for the private label photo
        photoUrl: z.string(),
      }),
    ),
  }),
};
